import React, { useState } from "react";
import './ContactForm.css'
import axios from "axios";
export default function ContactForm() {

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [whatsappno, setWhatsappno] = useState("");
  const [comorfeed, setComorfeed] = useState("");


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/complain`, {
        name,
        surname,
        email,
        whatsappno,
        comorfeed
      });

      if (res.status === 201) {
        alert("Thank you!");
        setName("");
        setSurname("");
        setEmail("");
        setWhatsappno("");
        setComorfeed("");
      }
    } catch (err) {
      alert("Error submitting form");
      console.error(err);
    }
  };
  return (
    <>
      <form action="#" onSubmit={handleSubmit} method="post">
        <h2>Contact Form</h2>
        <div className="name">
          <div className="one">

            <label htmlFor="name">Name:</label>
            <input type="text" placeholder="Name" name="name" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="two">

            <label htmlFor="surname">Surname:</label>
            <input type="text" placeholder="Surname" name="surname" id="surname" value={surname} onChange={(e) => setSurname(e.target.value)} required />
          </div>
        </div>
        <div className="contact">
          <div className="one">

            <label htmlFor="email">Email:</label>
            <input type="email" name="email" id="email" placeholder="YOUREMAIL@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="two">

            <label htmlFor="whatsappno">Whatsapp Number:</label>
            <input type="text" name="whatsappno" id="whatsappno" value={whatsappno} placeholder="+92XXXXXXXXXX" onChange={(e) => setWhatsappno(e.target.value)} required />
          </div>
        </div>
        <div className="maincomplain">
          <label htmlFor="comorfeed">Complain / Feedback:</label>
          <textarea name="complain-or-feedback" id="comorfeed" cols="30" value={comorfeed} rows="8" placeholder="Feedbacks/Complains" onChange={(e) => setComorfeed(e.target.value)} required></textarea>
        </div>
        <button type="submit">Submit</button>
        <a href="https://wa.me/+923283411265" className="whatsapp">
          <i class="fa-brands fa-whatsapp"></i> Our Whatsapp
        </a>
      </form>

    </>
  )
}